import { useEffect, useState } from 'react'
import { agendaLabService } from '../../services/api'

const asArray = (value) => {
  if (Array.isArray(value)) return value
  if (Array.isArray(value?.items)) return value.items
  if (Array.isArray(value?.data)) return value.data
  if (Array.isArray(value?.$values)) return value.$values
  return []
}

export default function AgendaLabCalendar() {
  const [appointments, setAppointments] = useState([])
  const [error, setError] = useState('')

  useEffect(() => {
    const load = async () => {
      try {
        setError('')
        const from = new Date().toISOString()
        const to = new Date(Date.now() + 7 * 24 * 60 * 60 * 1000).toISOString()
        const response = await agendaLabService.getCalendar(from, to)
        setAppointments(asArray(response.data))
      } catch (err) {
        setError(err?.message || 'No se pudo cargar el calendario.')
        setAppointments([])
      }
    }

    load()
  }, [])

  return (
    <div className="space-y-4">
      <h1 className="text-2xl font-bold">Calendario</h1>
      {error && <div className="card p-3 text-sm text-red-700 bg-red-50 border border-red-200">{error}</div>}
      <div className="card p-4">
        {appointments.map((a) => (
          <div id={`appointment-${a.id}`} key={a.id} className="border-b py-2 text-sm">
            <div>{a.service?.name} - {a.client?.fullName}</div>
            <div className="text-gray-500">{a.client?.email || 'Sin email registrado'}</div>
            <div className="text-gray-500">{new Date(a.startAtUtc).toLocaleString()} - {new Date(a.endAtUtc).toLocaleString()}</div>
            <div className="text-xs text-gray-500">{a.notes ? `Descripción: ${a.notes}` : 'Sin descripción registrada.'}</div>
          </div>
        ))}
      </div>
    </div>
  )
}
